import { Route, Routes } from 'react-router-dom';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import InvoicesListV2 from './components/InvoicesListV2';
import InvoiceVerifyList from './components/InvoiceVerifyList';
import { InvoiceForm } from './components/InvoiceForm';
import InvoicesListContract from './components/InvoicesListContract';
import InvoiceLongTermRejectList from './components/InvoiceLongTermRejectList';

export function InvoiceRoutes() {
    return (
        <Routes>
            {/*{hasAccessRight(AdminAclEnum.INVOICES) && <Route exact path="/invoices" component={InvoicesList} />}*/}
            {hasAccessRight(AdminAclEnum.INVOICES) && <Route path="/v2" element={<InvoicesListV2 />} />}
            {hasAccessRight(AdminAclEnum.INVOICES) && <Route path="/contracts" element={<InvoicesListContract />} />}
            {hasAccessRight(AdminAclEnum.INVOICE_VERIFICATION) && (
                <>
                    <Route path="/verify" element={<InvoiceVerifyList />} />
                    <Route path="/contracts-verify" element={<InvoiceLongTermRejectList />} />
                    <Route path="/verify/edit/:id" element={<InvoiceForm />} />
                </>
            )}
        </Routes>
    );
}
